import React from "react";
import { PropTypes } from 'prop-types';
import { RowWrapper } from "../styles";
import { FormItemWrapper,NonGradedWrapperSSN } from "../styles";
import { DatePicker, Row, Col, Input, Tooltip } from "antd";
import moment from "moment";
import {
  SecurityNumWrap,
  InputWrapper,
  TitleWrapper,
  InputWrapperGraded,
  TitleWrapperTitle,
  InputWrapperDrop,
  NoResultsWrap,
  SelectOptionMainWrapper,
  TitleMarginTop,
  SelectdropwownStyles
} from "../styles";

import InputComponent from "./InputComponent";
import SelectComponent from "./SelectComponent";
import { TitleTextWrapper } from "../../../../../CommonComponents/commonStyles";
import Calendar from "../../../../../CommonComponents/Calendar/Calendar";

export default function UserInfoForms(props) {
  
  const disabledDate = current => {
    // Can not select days before today and today
    return current && current > moment().endOf("day");
  };

  const dataForSuffix = () => {
    if (props.state.tempToDisplayOnly.secondaryGender != undefined) {
      return props.state.tempToDisplayOnly.secondarySuffix;
    } else {
      if (props.state.secondaryAdvisor.suffix != "") {
        return props.filterDropDownData(
          props.state.secondaryAdvisor.suffix,
          props.state.suffixDropDown
        );
      }
    }
  };

  const dataForGender = () => {
    if (props.state.tempToDisplayOnly.secondaryGender != undefined) {
      return props.state.tempToDisplayOnly.secondaryGender;
    } else {
      if (props.state.secondaryAdvisor.gender != "") {
        if (props.state.secondaryAdvisor.gender != undefined) {
          return props.getGenderDesc(props.state.secondaryAdvisor.gender);
        }
      }
    }
  };

  const dataForTitle = () => {
    if (props.state.tempToDisplayOnly.secondaryTitle != undefined) {
      return props.state.tempToDisplayOnly.secondaryTitle;
    } else {
      if (props.state.secondaryAdvisor.title != "") {
          return props.filterDropDownData(
            props.state.secondaryAdvisor.title,
            props.state.titleDropDown
          );
      }
    }
  };

  const generateViewForDropDown = (value , dropdown) => {
    if(value == "" || value == null){
      return undefined;
    }
    let desc = props.filterDropDownData(value,dropdown);
    return desc;
  }
  return (    
    <div>
      <Row gutter={24}>
        <Col lg={{ span: 8 }} md={{ span: 10 }}>
          <FormItemWrapper
            colon={false}
            label={<TitleWrapperTitle>Title (optional)</TitleWrapperTitle>}
          >
            <SelectOptionMainWrapper>
              <InputWrapperDrop>
                <SelectdropwownStyles>
                  <div id={"titleEditable"} style={{ position: "relative" }}>
                    {props.state.advisorType == "Primary" ? (
                        props.state.primaryAdvisor.title === props.state.tempInfo.title
                        && props.state.tempInfo.title !== null ? (
                          // DropDown for Title For Primary Advisor with title [DISABLED]
                          <SelectComponent
                            showSearch
                            name="title"
                            placeholder="Enter title"
                            disabled
                            showArrow={false}
                            value={props.state.primaryAdvisor.title && props.filterDropDownData(
                              props.state.primaryAdvisor.title,
                              props.state.titleDropDown,
                              "Title"
                            )}
                            dropdown={props.state.titleDropDown}
                          />
                        ):(
                          // DropDown for Title For Primary Advisor with no title
                          <SelectComponent
                            showSearch
                            name="title"
                            onSelect={e => props.onChange("title", e)}
                            showArrow={false}
                            defaultActiveFirstOption={false}
                            value={generateViewForDropDown(props.state.primaryAdvisor.title,props.state.titleDropDown)}
                            placeholder="Enter title"
                            dropdown={props.state.titleDropDown}
                            data-test="title_select_component"
                          />
                        )
                    ) : (
                      // DropDown for Title For Secondary Advisor with no title
                      <SelectComponent
                        showSearch
                        name="title"
                        data-test="withoutprimarytitle"
                        onSelect={e => props.onChange("title", e)}
                        showArrow={false}
                        value={dataForTitle()}
                        defaultActiveFirstOption={false}
                        placeholder="Enter title"
                        dropdown={props.state.titleDropDown}
                      />
                    )}
                  </div>
                </SelectdropwownStyles>
              </InputWrapperDrop>
            </SelectOptionMainWrapper>
          </FormItemWrapper>
        </Col>
      </Row>

      <RowWrapper>
        <Row gutter={24}>
          <Col lg={{ span: 8 }} md={{ span: 10 }}>
            <FormItemWrapper
              colon={false}
              label={
                <TitleMarginTop>
                  <TitleWrapper>First Name</TitleWrapper>
                </TitleMarginTop>
              }
            >
              {props.state.advisorType == "Primary" ? (
                 <>
                  {props.state.primaryAdvisor.firstname == props.state.tempInfo.firstname 
                  && props.state.tempInfo.firstname != null ? (
                  <InputWrapperGraded>
                    <InputComponent
                      ariaLabel="first-name"
                      disabled
                      placeholder="Enter name"
                      value={
                        props.state.primaryAdvisor &&
                        props.state.primaryAdvisor.firstname
                      }
                      id={props.id&&("txtName"+props.id)}
                    />
                  </InputWrapperGraded>
                  ):(
                    <InputWrapper>
                      <InputComponent
                        ariaLabel="first-name"
                        id={props.id&&("txtName"+props.id)}
                        name="firstname"
                        data-test="firstname"
                        maxLength="150"
                        onBlur={event => {
                          props.handleInputBlur(event, "firstname", 1);
                        }}
                        onChange={e => props.handleChange(e)}
                        value={props.state.primaryAdvisor.firstname}
                        placeholder="Enter first name"
                      />
                        {props.state.primaryErrors.firstname && (
                          <div>{props.state.primaryErrors.firstname[1]}</div>
                        )}
                    </InputWrapper>
                  )}
                  </>
              ) : (
                <InputWrapper>
                  <InputComponent
                    data-test="withoutprimaryfirstname"
                    ariaLabel="first-name"
                    id={props.id&&("txtName"+props.id)}
                    name="firstname"
                    maxLength="150"
                    onBlur={event => {
                      props.handleInputBlur(event, "firstname", 1);
                    }}
                    onChange={e => props.handleChange(e)}
                    value={props.state.secondaryAdvisor.firstname}
                    placeholder="Enter first name"
                  />
                  {props.state.secondaryErrors.firstname && (
                    <div>{props.state.secondaryErrors.firstname[1]}</div>
                  )}
                </InputWrapper>
              )}
            
            </FormItemWrapper>
          </Col>
          <Col lg={{ span: 8 }} md={{ span: 10 }}>
            <FormItemWrapper
              colon={false}
              label={
                <TitleMarginTop>
                  <TitleWrapper>Middle Name (optional)</TitleWrapper>
                </TitleMarginTop>
              }
            >
              {props.state.advisorType == "Primary" ? (
                  <>
                  {props.state.primaryAdvisor.middlename == props.state.tempInfo.middlename 
                  && props.state.primaryAdvisor.middlename != null ? (
                    <InputWrapperGraded>
                      <InputComponent
                        ariaLabel="middle-name"
                        disabled
                        placeholder="Enter middle name"
                        maxLength="150"
                        value={
                          props.state.primaryAdvisor &&
                          props.state.primaryAdvisor.middlename
                        }
                        id={props.id&&("txtMiddleName"+props.id)}
                      />
                    </InputWrapperGraded>
                  ) : (
                    <InputWrapper>
                      <InputComponent
                        ariaLabel="middle-name"
                        name="middlename"
                        data-test="middlename"
                        onChange={e => props.handleChange(e)}
                        value={props.state.primaryAdvisor.middlename}
                        maxLength="150"
                        placeholder="Enter middle name"
                        id={props.id&&("txtMiddleName"+props.id)}
                      />
                    </InputWrapper>
                  )}
                  </>
              ) : (
                <InputWrapper>
                  <InputComponent
                    ariaLabel="middle-name"
                    data-test="withoutprimarymiddlename"
                    name="middlename"
                    id={props.id&&("txtMiddleName"+props.id)}
                    onChange={e => props.handleChange(e)}
                    value={props.state.secondaryAdvisor.middlename}
                    maxLength="150"
                    placeholder="Enter middle name"
                  />
                </InputWrapper>
              )}
            </FormItemWrapper>
          </Col>
          <Col lg={{ span: 8 }} md={{ span: 10 }}>
            <FormItemWrapper
              colon={false}
              label={
                <TitleMarginTop>
                  <TitleWrapper>Last Name</TitleWrapper>
                </TitleMarginTop>
              }
            >
              {props.state.advisorType == "Primary" ? (
                // props.state.primaryAdvisor.lastname != null ? (
                  <>
                    {props.state.primaryAdvisor.lastname == props.state.tempInfo.lastname 
                    && props.state.primaryAdvisor.lastname != null ? (
                      <InputWrapperGraded>
                        <InputComponent
                          ariaLabel="last-name"
                          disabled
                          placeholder="Enter last name"
                          value={
                            props.state.primaryAdvisor &&
                            props.state.primaryAdvisor.lastname
                            
                          }
                          id={props.id&&("txtLastName"+props.id)}
                        />
                      </InputWrapperGraded>
                    ):(
                      <InputWrapper>
                        <InputComponent
                          ariaLabel="last-name"
                          data-test="last-name"
                          onBlur={event => {
                            props.handleInputBlur(event, "lastname", 1);
                          }}
                          onChange={e => props.handleChange(e)}
                          placeholder="Enter last name"
                          name="lastname"
                          maxLength="150"
                          id={props.id&&("txtLastName"+props.id)}
                          value={props.state.primaryAdvisor.lastname}
                        />
                        {props.state.primaryErrors.lastname && (
                          <div>{props.state.primaryErrors.lastname[1]}</div>
                        )}
                      </InputWrapper>
                    )}
                  </>
              ) : (
                <InputWrapper>
                  <InputComponent
                    ariaLabel="last-name"
                    data-test="last-name2"
                    onBlur={event => {
                      props.handleInputBlur(event, "lastname", 1);
                    }}
                    onChange={e => props.handleChange(e)}
                    placeholder="Enter last name"
                    name="lastname"
                    maxLength="150"
                    value={props.state.secondaryAdvisor.lastname}
                    id={props.id&&("txtLastName"+props.id)}
                  />
                  {props.state.secondaryErrors.lastname && (
                    <div>{props.state.secondaryErrors.lastname[1]}</div>
                  )}
                </InputWrapper>
              )}
            </FormItemWrapper>
          </Col>
        </Row>
      </RowWrapper>

      <RowWrapper>
        <Row gutter={24}>
          <Col lg={{ span: 8 }} md={{ span: 10 }}>
            <FormItemWrapper
              colon={false}
              label={
                <TitleMarginTop>
                  <TitleWrapper>Suffix (optional)</TitleWrapper>
                </TitleMarginTop>
              }
            >
              <SelectOptionMainWrapper>
                <InputWrapperDrop>
                  <SelectdropwownStyles>
                    <div id={"suffixEditable"} style={{ position: "relative" }}>
                      {props.state.advisorType == "Primary" ? (
                          props.state.primaryAdvisor.suffix == props.state.tempInfo.suffix 
                           && props.state.tempInfo.suffix !== null ? (
                            // DropDown for Title For Primary Advisor with title [DISABLED]
                            <>
                              <SelectComponent
                                ariaLabel="suffix"
                                showSearch
                                name="suffix"
                                placeholder="Enter suffix"
                                disabled
                                showArrow={false}
                                value={props.filterDropDownData(
                                  props.state.primaryAdvisor.suffix,
                                  props.state.suffixDropDown,
                                  "Suffix"
                                )}
                                dropdown={props.state.suffixDropDown}
                                id={props.id&&("selSuffix"+props.id)}
                              />
                            </>
                          ):(
                            // DropDown for Title For Primary Advisor with no suffix
                            <>
                              <SelectComponent
                                ariaLabel="suffix"
                                showSearch
                                name="suffix"
                                data-test="wpsuffix"
                                id={props.id&&("selSuffix"+props.id)}
                                onSelect={e => props.onChange("suffix", e)}
                                showArrow={false}
                                defaultActiveFirstOption={false}
                                value={generateViewForDropDown(props.state.primaryAdvisor.suffix,props.state.suffixDropDown)}
                                placeholder="Enter suffix"
                                dropdown={props.state.suffixDropDown}
                              />
                            </>
                          )
                      ) : (
                        // DropDown for Title For Secondary Advisor with no title
                        <>
                          <SelectComponent
                            ariaLabel="suffix"
                            showSearch
                            name="suffix"
                            data-test="dataForSuffix"
                            id={props.id&&("selSuffix"+props.id)}
                            onSelect={e => props.onChange("suffix", e)}
                            showArrow={false}
                            value={dataForSuffix()}
                            defaultActiveFirstOption={false}
                            placeholder="Enter suffix"
                            dropdown={props.state.suffixDropDown}
                            
                          />
                        </>
                      )}
                    </div>
                  </SelectdropwownStyles>
                </InputWrapperDrop>
              </SelectOptionMainWrapper>
            </FormItemWrapper>
          </Col>
          <Col lg={{ span: 8 }} md={{ span: 10 }}>
            <FormItemWrapper
              colon={false}
              label={
                <TitleMarginTop>
                  <TitleWrapper>Date of Birth</TitleWrapper>
                </TitleMarginTop>
              }
            >
              {props.tabKey == "Primary" ? (
                  <>
                  {props.state.primaryAdvisor.dob === props.state.tempInfo.dob 
                    && props.state.tempInfo.dob !== null ? (
                    <InputWrapperGraded>
                      <DatePicker
                        aria-label="date-of-birth"
                        format="MM/DD/YYYY"
                        disabled
                        value={
                          props.state.primaryAdvisor &&
                          props.state.primaryAdvisor.dob &&
                          props.getDateOfBirth(props.state.primaryAdvisor.dob)
                        }
                      />
                    </InputWrapperGraded>
                  ):(
                    <InputWrapper height="22px">
                      <Calendar
                        ariaLabel="data-of-birth"
                        id="primaryPicker"
                        name="dob"
                        data-test="calendar"
                        format="MM/DD/YYYY"
                        disabledDate={disabledDate}
                        allowClear={false}
                        placeHolder="Select date"
                        onBlur={event => {
                          props.handleDropDownBlur(event, "dob", 1);
                        }}
                        onChange={e => props.handleDOBChange("dob", e)}
                        value={
                          props.state.primaryAdvisor.dob &&
                          props.getDateOfBirth(props.state.primaryAdvisor.dob)
                        }
                      />
                      {props.state.primaryErrors.dob && (
                        <div>{props.state.primaryErrors.dob[1]}</div>
                      )}
                    </InputWrapper>
                  )}
                  </>
              ) : (
                <InputWrapper height="22px">
                  <Calendar
                    ariaLabel="data-of-birth"
                    id="secondaryPicker"                    
                    name="dob"
                    format="MM/DD/YYYY"
                    disabledDate={disabledDate}
                    allowClear={false}
                    placeHolder="Select date"
                    onBlur={event => {
                      props.handleDropDownBlur(event, "dob", 1);
                    }}
                    onChange={e => props.handleDOBChange("dob", e)}
                    value={
                      props.state.secondaryAdvisor.dob &&
                      props.getDateOfBirth(props.state.secondaryAdvisor.dob)
                    }
                  />
                  <>
                    {props.state.secondaryErrors.dob && (
                      <div>{props.state.secondaryErrors.dob[1]}</div>
                    )}
                  </>
                </InputWrapper>
              )}
            </FormItemWrapper>
          </Col>
          <Col lg={{ span: 8 }} md={{ span: 10 }}>
            <FormItemWrapper
              colon={false}
              label={
                <TitleMarginTop>
                  <TitleWrapper>Gender (optional)</TitleWrapper>
                </TitleMarginTop>
              }
            >
              <SelectOptionMainWrapper>
                <InputWrapperDrop>
                  <SelectdropwownStyles>
                    <div id={"gender"} style={{ position: "relative" }}>
                      {props.state.advisorType == "Primary" ? (
                          <>
                           {props.state.primaryAdvisor.gender == props.state.tempInfo.gender 
                            && props.state.primaryAdvisor.gender != null ? (
                             <SelectComponent
                              ariaLabel="gender"
                              name="gender"
                              showArrow={false}
                              id={props.id && ("selGender"+props.id)}
                              disabled
                              value={
                                props.state.primaryAdvisor &&
                                props.state.primaryAdvisor.gender ?
                                props.getGenderDesc(
                                  props.state.primaryAdvisor.gender
                                ) : undefined
                              }
                              dropdown={props.state.genderDropDown}
                            />
                           ) : (
                              <SelectComponent
                                ariaLabel="gender"
                                defaultActiveFirstOption={false}
                                notFoundContent={
                                  <NoResultsWrap>No results</NoResultsWrap>
                                }
                                data-test="findgender"
                                id={props.id && ("selGender"+props.id)}
                                showSearch
                                placeholder="Enter gender"
                                name="gender"
                                onSelect={e => props.onChange("gender", e)}
                                value={generateViewForDropDown(props.state.primaryAdvisor.gender,props.state.genderDropDown)}
                                dropdown={props.state.genderDropDown}
                              />
                           )}
                          </>
                      ) : (
                        <>
                          <SelectComponent
                            ariaLabel="gender"
                            data-test="test-gender"
                            defaultActiveFirstOption={false}
                            notFoundContent={
                              <NoResultsWrap>No results</NoResultsWrap>
                            }
                            showSearch
                            id={props.id && ("selGender"+props.id)}
                            name="gender"
                            placeholder="Enter gender"
                            onSelect={e => props.onChange("gender", e)}
                            value={dataForGender()}
                            dropdown={props.state.genderDropDown}
                          />
                          <>
                          </>
                        </>
                      )}
                      
                    </div>
                  </SelectdropwownStyles>
                </InputWrapperDrop>
              </SelectOptionMainWrapper>
            </FormItemWrapper>
          </Col>
        </Row>
      </RowWrapper>

      <RowWrapper>
        <Row gutter={24}>
          <Col lg={{ span: 8 }} md={{ span: 10 }}>
            <FormItemWrapper
              colon={false}
              label={
                <TitleMarginTop>
                  <TitleTextWrapper>Last 4 digits of Social Security Number / PIN</TitleTextWrapper>
                </TitleMarginTop>
              }
            >
              {props.state.advisorType == "Primary" ? (
                <InputWrapperGraded>
                  <SecurityNumWrap>
                    <Tooltip placement="bottom" title={"Last 4 digits of Social Security Number / PIN."}>
                      <Input.Password
                        aria-label="ssn"
                        id={props.id&&("txtSSN"+props.id)}
                        disabled
                        placeholder="Last four digits only"
                        value={
                          props.state.primaryAdvisor &&
                          props.state.primaryAdvisor.ssn &&
                          props.state.primaryAdvisor.ssn
                        }
                      />
                    </Tooltip>
                  </SecurityNumWrap>
                </InputWrapperGraded>
              ) : (
                <InputWrapper>
                  <SecurityNumWrap>
                    <Tooltip placement="bottom" title={"Last four digits of SSN or PIN."}>
                      <NonGradedWrapperSSN>
                        <Input.Password
                          aria-label="enter-ssn"
                          id={props.id && ("txtSSN"+props.id)}
                          maxLength="4"
                          onBlur={event => {
                            props.handleInputBlur(event, "ssn", 1);
                          }}
                          data-test="ssn-test"
                          placeholder="Last four digits only"
                          name="ssn"
                          onChange={e => props.handleChange(e)}
                          value={props.state.secondaryAdvisor.ssn}
                        />
                        {props.state.secondaryErrors.ssn && (
                          <div>{props.state.secondaryErrors.ssn[1]}</div>
                        )}
                      </NonGradedWrapperSSN>
                    </Tooltip>
                  </SecurityNumWrap>
                </InputWrapper>
              )}
            </FormItemWrapper>
          </Col>
          {props.state.advisorType == "Secondary" && (

          <Col lg={{ span: 8 }} md={{ span: 10 }}>
            <FormItemWrapper
              colon={false}
              label={
                <TitleMarginTop>
                  <TitleTextWrapper>
                    Confirm last 4 digits of Social Security Number / PIN
                  </TitleTextWrapper>
                </TitleMarginTop>
              }
            >
                <InputWrapper>
                  <SecurityNumWrap>
                    <Tooltip placement="bottom" title={props.text}>
                      <Input.Password
                        aria-label="enter-ssn"
                        id={props.id && ("txtConfirmSSN"+props.id)}
                        onChange={e => props.handleChange(e)}
                        onBlur={event => {
                          props.handleInputBlur(event, "confirmSSN", 1);
                        }}
                        data-test = "secondaryssn"
                        name="confirmSSN"
                        value={
                             props.state.secondaryConfirmSSN
                        }
                        placeholder="Last four digits only"
                        maxLength="4"
                      />
                      {props.state.secondaryErrors.confirmSSN && (
                        <div>{props.state.secondaryErrors.confirmSSN[1]}</div>
                      )}
                    </Tooltip>
                  </SecurityNumWrap>
                </InputWrapper>
            </FormItemWrapper>
          </Col>
              )}
          </Row>
      </RowWrapper>
    </div>
  );
}

UserInfoForms.propTypes = {
  filterDropDownData: PropTypes.func,
  filterDropDownDataWithValue: PropTypes.func,
  getDateOfBirth: PropTypes.func,
  getGenderDesc: PropTypes.func,
  handleChange: PropTypes.func,
  handleDOBChange: PropTypes.func,
  handleDropDownBlur: PropTypes.func,
  handleInputBlur: PropTypes.func,
  id: PropTypes.string,
  onChange: PropTypes.func,
  props: PropTypes.object,
  state: PropTypes.object,
  tabKey: PropTypes.string,
}